"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Domain = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var is_not_empty_string_1 = require("../class-validators/is-not-empty-string");
var domain_builder_1 = require("../builders/domain-builder");
var notification_action_1 = require("./notification-action");
var web_apns_send_integration_config_1 = require("./send-integration-configurations/web-apns-send-integration-config");
var native_apns_send_integration_config_1 = require("./send-integration-configurations/native-apns-send-integration-config");
var native_fcm_send_integration_config_1 = require("./send-integration-configurations/native-fcm-send-integration-config");
var currency_code_1 = require("./currency-code");
var domain_ecomm_configuration_1 = require("./domain-ecomm-configuration");
var domain_utm_params_1 = require("./domain-utm-params");
var domain_global_prompt_settings_1 = require("./domain-global-prompt-settings");
var notification_frequency_caps_config_1 = require("./notification-frequency-caps-config");
var abstract_struct_1 = require("./abstract-struct");
var with_default_value_1 = require("../class-transformers/with-default-value");
var case_insensitive_ingest_1 = require("../class-transformers/case-insensitive-ingest");
var Domain = (function (_super) {
    __extends(Domain, _super);
    function Domain() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Domain, "Builder", {
        get: function () {
            return new domain_builder_1.DomainBuilder();
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsPositive)(),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], Domain.prototype, "id", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'account_name' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Domain.prototype, "accountName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'account_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsPositive)(),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], Domain.prototype, "accountId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Domain.prototype, "name", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'display_name' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Domain.prototype, "displayName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'time_zone' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Domain.prototype, "timeZone", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'currency_code' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Domain.prototype, "currencyCode", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function (_) { return currency_code_1.CurrencyCode; }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", currency_code_1.CurrencyCode)
    ], Domain.prototype, "currency", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'domain_key' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Domain.prototype, "domainKey", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'delivery_throttle_max_seconds' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.Min)(0),
        (0, class_validator_1.Max)(900),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], Domain.prototype, "deliveryThrottleMaxSeconds", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'status_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsPositive)(),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], Domain.prototype, "statusId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Domain.prototype, "status", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'sender_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "senderId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'fcm_server_key' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "fcmServerKey", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'vapid_public_key' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Domain.prototype, "vapidPublicKey", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'default_icon_url' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "defaultIconUrl", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'default_badge_url' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "defaultBadgeUrl", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'default_notification_ttl_seconds' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "defaultNotificationTtlSeconds", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'global_prompt_settings' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function (_) { return domain_global_prompt_settings_1.DomainGlobalPromptSettings; }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "globalPromptSettings", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'ecomm_config' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function (_) { return domain_ecomm_configuration_1.DomainEcommConfiguration; }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "ecommConfig", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'utm_params' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return domain_utm_params_1.DomainUtmParams; }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "utmParams", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.ArrayUnique)(),
        __metadata("design:type", Array)
    ], Domain.prototype, "flags", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'account_flags' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.ArrayUnique)(),
        __metadata("design:type", Array)
    ], Domain.prototype, "accountFlags", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'frequency_caps' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "frequencyCaps", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'notification_frequency_caps' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.ValidateNested)({ each: true }),
        (0, class_transformer_1.Type)(function (_) { return notification_frequency_caps_config_1.NotificationFrequencyCapsConfig; }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "notificationFrequencyCaps", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'created_at' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "createdAt", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'updated_at' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "updatedAt", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'apns_configuration' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return web_apns_send_integration_config_1.WebApnsSendIntegrationConfig; }),
        __metadata("design:type", web_apns_send_integration_config_1.WebApnsSendIntegrationConfig)
    ], Domain.prototype, "apnsConfiguration", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'native_apns_configuration' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return native_apns_send_integration_config_1.NativeApnsSendIntegrationConfig; }),
        __metadata("design:type", native_apns_send_integration_config_1.NativeApnsSendIntegrationConfig)
    ], Domain.prototype, "nativeApnsConfiguration", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'native_fcm_configuration' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return native_fcm_send_integration_config_1.NativeFcmSendIntegrationConfig; }),
        __metadata("design:type", native_fcm_send_integration_config_1.NativeFcmSendIntegrationConfig)
    ], Domain.prototype, "nativeFcmConfiguration", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'whitelist_domains' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.ArrayUnique)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "whitelistDomains", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'sdk_event_only_domains' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.ArrayUnique)(),
        __metadata("design:type", Array)
    ], Domain.prototype, "sdkEventOnlyDomains", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'landing_url_domain_whitelist' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.ArrayUnique)(),
        __metadata("design:type", Array)
    ], Domain.prototype, "landingUrlDomainWhitelist", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'media_quality' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "mediaQuality", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'display_meta' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "displayMeta", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'default_notification_action_labels' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "defaultNotificationActionLabels", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'default_notification_actions' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.IsArray)(),
        (0, class_validator_1.ValidateNested)({ each: true }),
        (0, class_transformer_1.Type)(function () { return notification_action_1.NotificationAction; }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "defaultNotificationActions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'notification_auto_suggest_fields' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "notificationAutoSuggestFields", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'added_notification_query_params' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "addedNotificationQueryParams", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'collapse_key_type' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        __metadata("design:type", String)
    ], Domain.prototype, "collapseKeyType", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'routing_key' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "routingKey", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'created_by' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.Min)(0),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "createdBy", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'update_by' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.Min)(0),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "updatedBy", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'created_by_username' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "createdByUsername", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'update_by_username' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "updatedByUsername", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'prod_domain_id' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, with_default_value_1.WithDefaultValue)(null),
        (0, class_validator_1.Min)(0),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], Domain.prototype, "prodDomainId", void 0);
    return Domain;
}(abstract_struct_1.AbstractStruct));
exports.Domain = Domain;
//# sourceMappingURL=domain.js.map